module.exports = __webpack_public_path__ + "img/graphic-2.560d813b.png";